module.exports = __webpack_public_path__ + "static/media/multiply_up.b0d94038.mp3";